import { motion } from 'framer-motion';
import styled from 'styled-components';
import { BREAKPOINTS } from 'styles/media';

export const ResourceSubmissionTagsFieldOverallWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ResourceSubmissionTagsFieldSubtitle = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: normal;

  color: ${({ theme }) => (theme.isError ? 'var(--color-error)' : 'var(--color-text)')};
`;

export const ResourceSubmissionTagsFieldTagCategoriesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  padding: ${({ theme }) => (theme.isError ? '9px' : '10px')};
  border-radius: 8px;

  ${({ theme }) => theme.isError && 'border: 1px solid var(--color-error);'}
`;

export const ResourceSubmissionTagsFieldSearchWrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  padding: 16px 10px;

  ${({ theme }) =>
    theme.isError &&
    `
    padding: 15px 9px;
    border: 1px solid var(--color-error);
  `}

  border-radius: 8px;
  background: rgba(173, 173, 173, 0.08);

  position: relative;
`;

export const ResourceSubmissionTagsFieldSearchSelectedTags = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 6px;

  overflow-x: auto;

  scrollbar-width: none;
  scrollbar-gutter: stable;
`;

export const ResourceSubmissionTagsFieldSearchInputContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ResourceSubmissionTagsFieldSearchInput = styled.input`
  flex: 1;

  ${BREAKPOINTS.tablet} {
    font-size: 16px;
  }

  &::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: normal;
    color: var(--color-data-alumni-background);
  }
`;

export const ResourceSubmissionTagsFieldSearchIconContainer = styled.div`
  min-width: 44px;
  min-height: 44px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 100%;
`;

interface ResourceSubmissionTagsFieldContainerProps {
  active: boolean;
}

export const ResourceSubmissionTagsFieldContainer = styled.div<ResourceSubmissionTagsFieldContainerProps>`
  display: flex;
  align-items: center;

  padding: 4px 8px;

  border-radius: 26px;
  border: 1px solid ${({ active }) => (active ? 'var(--color-data-skill-background)' : '#323f5d')};

  cursor: pointer;

  background: ${({ active }) => (active ? 'var(--color-data-skill-background)' : 'transparent')};
`;

export const ResourceSubmissionTagsFieldLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;

  color: #323f5d;
`;

//TAGS DROPDOWN
export const ResourceSubmissionTagsFieldSearchTagsDropdownWrapper = styled(motion.div).attrs({
  initial: { maxHeight: 0 },
  animate: { maxHeight: 200 },
  exit: { maxHeight: 0 },
})`
  width: 100%;

  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;

  display: flex;
  flex-direction: column;

  border-radius: 0px 0px 26px 26px;
  background: #fff;

  & > :last-child {
    padding: 3px 24px 19px 18px;
  }

  overflow-y: auto;
  transform: translateY(100%);
  z-index: 2;
`;

export const ResourceSubmissionTagsFieldSearchTagsDropdownItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding: 3px 24px 3px 18px;

  cursor: pointer;
`;

export const ResourceSubmissionTagsFieldSearchTagsDropdownItemAdd = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: var(--color-text);

  padding: 2px 8px;
  border-radius: 16px;
  background: #ffc229;
`;

export const ResourceSubmissionTagsFieldSearchTagsDropdownItemAlreadyAdded = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  text-align: center;

  color: rgba(23, 28, 51, 0.5);
`;

interface ResourceSubmissionTagsFieldSearchTagsDropdownItemLabelProps {
  alreadyAdded?: boolean;
}

export const ResourceSubmissionTagsFieldSearchTagsDropdownItemLabel = styled.span<ResourceSubmissionTagsFieldSearchTagsDropdownItemLabelProps>`
  font-weight: 400;
  font-size: 16px;
  line-height: normal;
  color: ${({ alreadyAdded }) => (alreadyAdded ? 'rgba(23, 28, 51, 0.5)' : 'var(--color-text)')};
`;

//TAG PILL
export const ResourceSubmissionTagsFieldSearchTagsPill = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 8px 16px 8px 24px;
  border-radius: 50px;
  border: 1px solid #000000;

  & > [data-action='remove'] {
    display: none;

    ${BREAKPOINTS.tablet} {
      display: flex;
    }
  }

  &:hover {
    & > [data-action='remove'] {
      display: flex;
    }
  }

  ${BREAKPOINTS.tablet} {
    padding: 4px 8px 4px 12px;
  }
`;

export const ResourceSubmissionTagsFieldSearchTagsPillLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  text-wrap: nowrap;

  color: var(--color-text);
`;

export const ResourceSubmissionTagsFieldSearchTagsPillIcon = styled.div`
  width: 24px;
  height: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
`;
